import Vue from 'vue'
import App from './App'
//引入模块
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueRouter from 'vue-router'
import axios from 'axios' //引入axios
//本地路由
import router from './router'
//全局变量
import global_ from './common/Global'//引用全局文件

import  VueJsonp  from  'vue-jsonp'

import Print from '@/plugs/print' // 引入附件的js文件打印
import qrcode from 'qrcode' //引入创建二维码模块
Vue.use(Print) // 注册

Vue.prototype.GLOBAL = global_//挂载到Vue实例上面
Vue.prototype.$ajax=axios //修改Vue的原型属性
axios.defaults.withCredentials=true
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueJsonp)



//路由守卫，登录态验证
router.beforeEach((to, from, next) => {
	if (to.path == '/login') {
	    sessionStorage.removeItem('organ');
	}
	let organ = JSON.parse(sessionStorage.getItem('organ'));
	if (!organ && to.path != '/login') {
	    next({ path: '/login' })
	} else {
	    next()
	}
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js